<template>


    <section class="section pt-5 pb-5">
        <div class="container position-relative">
            <div class="mb-5">
                <div class="conatiner-logo-general">
                    <router-link to="/"><img src="@/assets/talento_agv/img/AV_Logo_NEW_Purple_RGB_800.png" alt="" srcset=""></router-link>
                </div>

                <h3 class="header-title text-center agv-text">
                    {{ section_one.title }}
                </h3>
                <!-- <hr class="separador-title bg-info-separador"> -->
                <h4 class="link-cultura" style="font-size:20px; color: #000;"><router-link to="/"
                        class="item-link-cultura">Inicio</router-link> /
                    Escuela Corporativa</h4>
            </div>
            <div>
                <p class="text-center">{{ section_one.text }}</p>
            </div>
            <div class="video-banner-young">
                <iframe v-if="section_one.video" class="iframe-banner"
                    :src="`${section_one.video}&autoplay=1&muted=1&loop=1&background=1`" frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen muted>
                </iframe>
                <div class="sobrefondo" style="background-color: rgba(0, 0, 0, 0.3) !important"></div>

                <div class="container-block-video-young">
                    <div class="row">
                        <!-- <div class="col-12 col-md-12">
                            <h3 class="title-video" style="width: 60%;">
                                <img class="imag-arrow" src="@/assets/talento_agv/img/arrow-white.png" alt="">
                                Impulsando el crecimiento y la innovación en la agricultura a través del conocimiento.
                            </h3>
                        </div> -->
                        <div class="col-12 col-md-12 text-center">
                            <div class="container-play-young">
                                <a href="javascript:;" @click="eventDialogVideo(section_one.video)">
                                    <div class="container-icon-video-young">
                                        <i class='bx bx-play'></i>
                                    </div>
                                    <div>
                                        <h4>Ver el video</h4>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section pt-5 pb-5 company-hire nuestros_lideres" style="position:relative">
        <div class="container">
            <div class="row">
                <div v-for="items in dataVideo" class="col-12 col-md-6">
                    <div class="video-banner-young" style="min-height: 324px !important; ">
                        <iframe class="iframe-banner" :src="`${items.url}&autoplay=1&muted=1&loop=1&background=1`"
                            frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen muted>
                        </iframe>

                        <div class="sobrefondo" style="background-color: rgba(0, 0, 0, 0.3) !important"></div>

                        <div class="container-block-video-young video-card">
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <h6 class="title-card-video">{{ items.description }}</h6>
                                </div>
                                <div class="col-12 col-md-12 text-center">
                                    <div class="container-play-young">
                                        <a @click="eventDialogVideo(items.url)" href="javascript:;">
                                            <div class="container-icon-video-young">
                                                <i class='bx bx-play'></i>
                                            </div>
                                            <div>
                                                <h4>Ver el video</h4>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section pt-5 pb-5" style="position:relative">
        <div class="container">

            <Carousel :autoplay="4000" class="mt-5 " :itemsToShow="toShow" :wrapAround="true" :transition="500">
                <Slide v-for="item in dataTestimonio" :key="item.id">
                    <div class="testimonio-area">
                        <div class="testimonio-content">
                            <div class="simple-testimotio" style="border: .4rem solid var(--bg-primary) !important;">
                                <div class="img-testimonio">
                                    <img :src="item.img" alt="" srcset="">
                                </div>
                                <div>
                                    <p>{{ item.decription }}</p>
                                    <div class="client-info">
                                        <h6>{{ item.name }}</h6>
                                        <span>{{ item.cargo }}</span>
                                        <!-- <span>
                                            <div class="rating-box">
                                                <div class="stars">
                                                    <i class="fa-solid fa-star active"></i>
                                                    <i class="fa-solid fa-star active"></i>
                                                    <i class="fa-solid fa-star active"></i>
                                                    <i class="fa-solid fa-star active"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                </div>
                                            </div>
                                        </span> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Slide>
            </Carousel>


        </div>
    </section>
    <!-- Crear Cuenta-->
    <section class="section job-register">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="register-job-blk">
                        <div class="job-content-blk aos aos-init aos-animate" data-aos="fade-up" data-aos-duration="500">
                            <h2>Sé el primero en recibir nuestras ofertas laborales</h2>
                            <p>Crea una cuenta y encuentra el trabajo que buscas.</p>

                            <router-link to="/crear_cuenta" class="btn all-btn">Crear Cuenta</router-link>
                            <router-link to="/login" class="btn all-btn">Ingresar</router-link>
                        </div>
                        <div class="see-all mt-0 aos aos-init aos-animate opportunity" data-aos="zoom-in" data-aos-duration="700">
                            <img src="@/assets/img/opportunity.png" alt="img">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="text-center pa-4">
        <v-dialog v-model="dialog" width="auto">
            <v-card max-width="900" class="modal-transparent">
                <template v-slot:text style="width: 100%; height: 600px;">
                    <iframe :src="urlVideo" frameborder="0" allow="autoplay; picture-in-picture; clipboard-write;"
                        style="width:800px;height:600px;" allowfullscreen></iframe>

                </template>
            </v-card>
        </v-dialog>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>

</template>
<script>
import axiosIns from '@/plugins/axios.js';
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default {
    data() {
        return {
            dialog: false,
            rating: 4.5,
            dataTestimonio: [
                // {
                //     img: "assets/talento_agv/img/nuestros_colaboradores/Javier Limo.jpg",
                //     decription: `Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet.`,
                //     name: "Javier Limo",
                //     cargo: "Comercio exterior"
                // },
                // {
                //     img: "assets/talento_agv/img/nuestros_colaboradores/Tania Martinez - Comex.jpg",
                //     decription: `Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet.`,
                //     name: "Tania Martinez",
                //     cargo: "Comercio exterior"
                // },
                // {
                //     img: "assets/talento_agv/img/nuestros_colaboradores/Hebert Custodio - Adminitración.jpg",
                //     decription: `Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet.`,
                //     name: "Hebert Custodio",
                //     cargo: "Administrador"
                // },
                // {
                //     img: "assets/talento_agv/img/nuestros_colaboradores/Jasmin Bravo -Comex.jpg",
                //     decription: `Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet, consectetuer adipiscing alit, sed. Lorem ipsum dolor sit amet.`,
                //     name: "Jasmin Bravo",
                //     cargo: "Comercio exterior"
                // },
            ],
            dataVideo: [
                // {
                //     url: "https://player.vimeo.com/video/695241421?h=743fd602df",
                //     description: "Juntos, cultivamos el futuro de la agricultura con innovación y sostenibilidad."
                // },
                // {
                //     url: "https://player.vimeo.com/video/695241421?h=743fd602df",
                //     description: "Juntos, cultivamos el futuro de la agricultura con innovación y sostenibilidad."
                // },
            ],
            urlVideo: '',
            toShow: 3,
            title: "Escuela Corporativa",
            text: "Inicio",
            text1: "Escuela Corporativa",

            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 1,
                    snapAlign: "center",
                },
                // 700px and up
                767: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                // 991px and up
                991: {
                    itemsToShow: 3.5,
                    snapAlign: "center",
                },
                // 1024 and up
            },
            images_carousel: [
                {
                    "id": "1",
                    "Img": "escuela_corp1.jpg",
                    "Title": "Social Media",
                    "Text": "Reach our Customers"
                },
                {
                    "id": "2",
                    "Img": "escuela_corp2.jpg",
                    "Title": "SEO",
                    "Text": "Unlock Growth Online"
                },
                {
                    "id": "3",
                    "Img": "escuela_corp3.jpg",
                    "Title": "SEO",
                    "Text": "Unlock Growth Online"
                },
                {
                    "id": "4",
                    "Img": "escuela_corp4.jpg",
                    "Title": "SEO",
                    "Text": "Unlock Growth Online"
                },
            ],

            section_one: [],
            section_two: [],

            language: null,
        };
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    mounted() {
        const script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        document.body.appendChild(script);

        this.getPageData()
        this.handleResize();
        this.getTestimonials()
        window.addEventListener('resize', this.handleResize);
    },
    methods: {
        getTestimonials(){
            const yo = this
            // yo.dataTableTestimonials = []
            // yo.dataTableFiltTestimonials = []
            const data = JSON.stringify({
              pagina : '4',
              seccion : '9',
            })
            // yo.dialogLoading = true
            const config = {
              method: 'post',
              url: '/talentoagv/readTestimonials/',
              headers: {
                'Content-Type': 'application/json'
              },
              data : data,
            }

            axiosIns(config)
                .then(function (response) {
                  // console.log(response.data['result'])
                  if (response.data['is_error'] === false){
                    let resultado = response.data['result']
                    let test = []
                    console.log("Información consultada", resultado)
                    for(let r of resultado){
                      // console.log(r)
                      if(r['key_idioma_id'] == yo.language){
                        test.push({
                          img: r['s3_url'],
                          decription: r['text'],
                          name: r['name'],
                          cargo: r['position']
                        })
                        // yo.dataTableTestimonials.push(r)
                        // yo.dataTableFiltTestimonials.push(r)
                      }
                    }
                    yo.dataTestimonio = test
                  }
                })
                .catch(function (error) {
                })
                .finally(function (){
                  // yo.dialogLoading = false
                })
        },
        eventDialogVideo(video) {
            this.dialog = true
            this.urlVideo = video
        },
        handleResize() {
            // Cambia la cantidad de itemsToShow según el ancho de la pantalla
            if (window.innerWidth <= 768) {  // Menos de 768px para dispositivos móviles
                this.toShow = 1;
            } else {
                this.toShow = 3;
            }
        },
        getPageData() {
            const yo = this
            const config = {
                method: 'get',
                url: '/talentoagv/getMainPageData/',
            }

            if (this.$store.getters.currentPublicLanguage == 'es') {
                yo.language = '1'
            }
            else if (this.$store.getters.currentPublicLanguage == 'en') {
                yo.language = '2'
            }

            axiosIns(config)
                .then(function (response) {
                    console.log(response.data['result'])
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        let experience = []
                        for (let r of resultado) {
                            if (r['idlanguage'] == yo.language) {
                                if (r['section'] == 'uno' && r['idpage'] == '4') {
                                    yo.section_one = r
                                } else if (r['section'] == 'dos' && r['idpage'] == '4') {
                                    // yo.section_two = r
                                  experience.push({ url: r.video, description: r.text })
                                }
                            }
                        }
                        // yo.section_one.photo = response.data['result'][]
                        // yo.$toastr.success(response.data['message'], 'Éxito')
                        yo.dataVideo = experience
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function () {

                })
        },
    }
};
</script>
<style>
.banner {
    width: 100vw;
    height: 280px;
    background-image: url('../../../../assets/img/fondo_principal_inicio.png');
    background-size: contain;
    background-position: center bottom;
}

.banner::after {
    content: '';
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 280px;
    background-color: rgba(0, 0, 0, 0.4);
    /* Color negro semi-transparente */
}

@media(max-width:1350px) {
    .testimonios_escuela .vector-rayas {
        height: 50% !important;
    }
}

@media(max-width:1280px) {
    .testimonios_escuela .vector-rayas {
        height: 30% !important;
    }
}

@media(max-width:1220px) {
    .testimonios_escuela .vector-rayas {
        height: 20% !important;
    }
}

@media(max-width:768px) {
    .testimonios_escuela .vector-rayas {
        height: 5% !important;
    }
}

@media(max-width:480px) {
    .titulo_banner {
        width: 400px !important;
        margin-left: -200px !important;
    }
}

@media(max-width:400px) {
    .titulo_banner {
        width: 360px !important;
        margin-left: -180px !important;
    }
}

/* Contenedor del testimonio */
.testimonio-area {
    display: grid;
    grid-template-rows: 1fr;
}

/* Estilos para el cuadro del testimonio */
.simple-testimotio {
    height: 450px; /* Establece una altura uniforme */
    padding: 20px;
    border: .4rem solid var(--bg-primary);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    text-align: center;
}

/* Asegura que la imagen y el texto tengan tamaños y márgenes uniformes */
.img-testimonio img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 30px;
    margin-top: -10px;
}

.testimonio-content p {
    font-size: 14px;
    line-height: 1.4;
    margin: 0 auto;
    flex-grow: 1; /* Permite que el texto ocupe el espacio necesario */
}

/* Responsividad para tabletas */
@media (max-width: 992px) {
    .simple-testimotio {
        height: 380px;
    }
    .img-testimonio img {
        width: 60px;
        height: 60px;
    }
    .testimonio-content p {
        font-size: 12px;
    }
}

/* Responsividad para dispositivos móviles grandes */
@media (max-width: 768px) {
    .simple-testimotio {
        width: 300px; /* Ajustar ancho para móviles grandes */
        height: 380px;
    }
    .img-testimonio img {
        width: 60px;
        height: 60px;
    }
    .testimonio-content p {
        font-size: 12px;
    }
}

/* Responsividad para dispositivos móviles pequeños */
@media (max-width: 576px) {
    .simple-testimotio {
        height: 390px;
    }
    .img-testimonio img {
        width: 50px;
        height: 50px;
        margin-bottom: 15px;
    }

}


</style>